function MenuDirective () {
  return {
    restrict: 'A',
    template: `
      
        <ul class="multilevel-menu">
        <li ng-repeat="item in menu" menu-item="item"></li>
       </ul>
    `,
    scope: {
      menu: '=menu',
      cls: '=ngClass'
    },
    replace: true,
    link: function link(scope, element, attrs) {
      element.addClass(attrs.class);
      element.addClass(scope.cls);
    }
  };
}

MenuDirective.$inject = [];

export default MenuDirective;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/home/menu/menu.directive.js
 **/